export class AxiosError extends Error {
	public statusCode: number;

	constructor(...params) {
		super(...params);

		// Set the prototype explicitly, this is required in some environments like Babel
		Object.setPrototypeOf(this, AxiosError.prototype);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, AxiosError);
		}
		const { errors } = params[0]?.response?.data ?? {};
		const responseErrorMessage = errors?.map((error) => error?.detail).join('\r\n');
		this.name = responseErrorMessage ? responseErrorMessage : 'Request error';
		this.statusCode = params[0]?.response?.status;
		const requestUrl = params[0]?.config?.url;
		const requestUrlMessage = !requestUrl ? '' : `. Request url: ${requestUrl}`;
		this.message = this.message + requestUrlMessage;
	}
}
